import { Form, SubmitFormButton, TextField } from '@calendly/form';
import { object, string } from '@calendly/form/validation';
import { useOnValueChange, useQueryParams } from '@calendly/hooks';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import LoadingState from 'components/core/loading_state';
import { Panel } from 'components/core/panel';
import { useConnectIcloudMutation, useFetchIcloudDataQuery } from 'features/calendar_connections/api';
import { FormHeader } from './form_header';
import { ICloudFormError } from './icloud_form_error';
import { FullStoryExclude } from '../../../shared/fullstory_privacy';
const containerCss = "cp2h8bg";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const formFieldCss = "f1muuf8r";
const FormField = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formFieldCss, props.className)} />;
});
const noteCss = "n1hr9ret";
const Note = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(noteCss, props.className)} />;
});
const helpUrl = 'https://help.calendly.com/hc/articles/236174208#tfa';
export const ConnectForm = () => {
  const {
    calendar_account_id: calendarAccountId
  } = useQueryParams();
  const history = useHistory();
  const {
    data,
    isLoading
  } = useFetchIcloudDataQuery(calendarAccountId, {
    skip: !calendarAccountId
  });
  const [connectIcloud, {
    error,
    isSuccess
  }] = useConnectIcloudMutation();
  useOnValueChange(isSuccess, () => {
    if (isSuccess) {
      history.push('/app/availability/calendar_settings');
    }
  });
  const initialValues = {
    calendarAccountId,
    email: data?.email || '',
    password: ''
  };
  const validationSchema = object({
    email: string().email().required(),
    password: string().required()
  });
  return <Panel>
      <FormHeader />
      {isLoading ? <LoadingState /> : <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={connectIcloud}>
              <Container>
                <div>
                  <FullStoryExclude>
                    <FormField as={TextField} name="email" type="email" label={I18n.t('publisher.calendar_settings.icloud.email_address')} placeholder={I18n.t('publisher.calendar_settings.icloud.email_address_placeholder')} />
                  </FullStoryExclude>
                  <FullStoryExclude>
                    <FormField as={TextField} name="password" type="password" label={I18n.t('publisher.calendar_settings.icloud.password')} placeholder={I18n.t('publisher.auth.password_placeholder')} />
                  </FullStoryExclude>
                </div>
                <ICloudFormError error={error?.message} />
                <SubmitFormButton>Connect</SubmitFormButton>
              </Container>
            </Form>}

      <Note>
        {HtmlParser(I18n.t('publisher.calendar_settings.icloud.security_note_html', {
        url: helpUrl
      }))}
      </Note>
    </Panel>;
};

require("./connect_form.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./connect_form.js");